let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bNPSl")).then(() => parcelRequire('8FYIq'));